module.exports = __webpack_public_path__ + "img/longArrow.f5e51718.svg";